// @TODO: move context import and handleGoToPlanos to parent component
import React from "react";
import Modal from "react-bootstrap/Modal";
import {useHistory} from "react-router-dom";
import "./AlertModal.scss";
import {CreditCard as CreditCardIcon} from "react-feather";
import Button from "@adoo-ui/Atom/Button";
import BeneficioCard from "./BeneficioCard/BeneficioCard";
import alertasCadastrados from "@images/modal-planos/alertas-cadastrados.jpeg";
import buscarTermos from "@images/modal-planos/buscar-termos.jpeg";
import navegacao from "@images/modal-planos/navegacao.jpeg";
import {routeCodes} from "@constants/routes";
import {usePlanoAlertaModal} from "@context/PlanoAlertaModal";

function AlertModal(props) {
  const history = useHistory();
  const {closeAlert} = usePlanoAlertaModal();

  const handleCloseModal = () => {
    props.onHide();
  };

  const handleGoToPlanos = () => {
    history.push(routeCodes.PLANOS_PRINCIPAL);
    closeAlert();
  };

  return (
    <Modal
      {...props}
      keyboard={true}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <CreditCardIcon />
      </Modal.Header>
      <Modal.Body>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flexAlign: "center",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h2>{props.config?.title}</h2>
          <h6>{props.config?.message}</h6>
        </div>

        <div className="beneficios mt-4">
          <BeneficioCard
            className="col-lg-4 col-md-6 col-sm-6 col-6"
            text="Navegue por muito mais Diários"
          >
            <img src={navegacao} alt="Navegue por muito mais Diários" />
          </BeneficioCard>
          <BeneficioCard
            className="col-lg-4 col-md-6 col-sm-6 col-6"
            text="Tenha uma busca mais livre e completa!"
          >
            <img src={buscarTermos} alt="Tenha uma busca mais livre e completa" />
          </BeneficioCard>
          <BeneficioCard
            className="col-lg-4 col-md-12 col-sm-12 col-6 mt-4"
            text="Crie mais alertas sem limitação de tempo!"
          >
            <img src={alertasCadastrados} alt="Crie mais alertas em limitação de tempo" />
          </BeneficioCard>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="adoo-btn adoo-btn--lg adoo-btn--bold mt-4 adoo-btn--planos-precos"
          onClick={handleGoToPlanos}
        >
          Ver planos e preços
        </Button>
        <Button
          className="adoo-btn adoo-btn--lg adoo-btn--bold mt-4 adoo-btn--nao-assinar"
          onClick={handleCloseModal}
        >
          Obrigado(a), agora não
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AlertModal;
